//@ts-ignore
import React, { useState, useEffect } from 'react'
import { saveAndEditClient, getClient, getClientRole, getUsers } from './ClientServices'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

const styles = {
    padding: { padding: '5px 10px' }
}

const UserListComponent = (props: any) => {
    const [resMsg, setResMsg] = useState('')
    const [clients, setClients] = useState([])
    const [users, setUsers] = useState([])


    const [clientId, setClientId] = useState('')
    useEffect(() => {
        getClient('')
            .then((res: any) => {
                setClients(res.responseObject)
            })
    }, [])
    
    const getUserName = (fname: string, lname: string) => {
        if(fname && lname) {
            return  `${fname} ${lname}`
        } else if(fname || lname) {
            if(fname) {
                return fname
            } else {
                return lname
            }
        } else {
            return ''
        }
    }
    if ('rahul.khanna@edfora.com' === props.userData.authenticatedUser.email) {

        return (
            <div>
                <div>
                    <div style={{ float: 'right' }}>
                        <Link style={styles.padding} to="/client" >Client</Link>
                        <Link style={styles.padding} to="/user" >User</Link>
                        <Link style={styles.padding} to="/role" >Role</Link>
                        <Link style={styles.padding} to="/user-list" >User List</Link>
                    </div>
                    <div><p>{resMsg}</p></div>
                    <h2> User list  </h2>
                    <select value={clientId} onChange={(e) => {
                        setClientId(e.target.value)

                        getUsers(e.target.value)
                            .then((res: any) => {
                                const users = res.responseObject
                                // users.pop()
                                setUsers(users)
                            })
                            .catch()
                    }}>
                        <option value=''> Select Client</option>
                        {clients.map((client: any) => {
                            return <option value={client._id}> {client.name}</option>
                        })}
                    </select>
                </div>
                <div>
                    <h2> </h2>
                    <table>
                        <tr>
                            <td>S no</td>
                            <td>Username</td>
                            <td>Email</td>
                            <td>Role</td>
                        </tr>
                        {users.map((user: any, index: number) => {
                            return <tr>
                                <td>{index + 1}</td>
                                <td>{getUserName(user.firstName, user.lastName)}</td>
                                <td>{user.email && user.email}</td>
                                <td>{user.role && user.role.role && user.role.role}</td>
                            </tr>
                        })}
                    </table>
                </div>
            </div>
        )
    } else {
        return <h1> Not permitted </h1>
    }
}



const mapStateToProps = (state: any) => ({
    userData: state.loginData.userData
})


export default connect(mapStateToProps)(UserListComponent);
